<h6 class="mt-3 m-2">Groups</h6>

<era-pane>
  <div class="list-group list-group-flush">
    @for (group of groups(); track group) {
      <div class="list-group-item d-flex pe-3 align-items-center">
        <span class="flex-grow-1">
          <a>{{ group.displayName || group.name }}</a>
          @if (group.inherited) {
            <p class="mb-0 lh-1"><small>Inherited</small><br /></p>
          }
        </span>
        @if (isEditing() && !group.inherited) {
          <button type="button"
                  class="btn btn-sm btn-outline-danger border-0"
                  id="{{ 'delete-group-button-' + group.id }}"
                  (click)="delete(group)">
            <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
          </button>
        }
      </div>
    }
  </div>
  @if (groups()?.length === 0) {
    <p class="mb-0">
      <span>No groups configured.</span>
    </p>
  }
</era-pane>